import { SLUG_SPORTS, INSTRUCTION_SLUGS } from '~/constants'

export const IFRAME_GAME_URLS = {
  VIRTUAL_SPORTS: `/${SLUG_SPORTS.V_SPORTS}`,
  ESPORTS: `/${SLUG_SPORTS.E_SPORTS}`,
  LIVE_CASINO: '/casino',
  VIRTUAL_GAME: '/virtualgame',
  SABA_CLUB: '/saba-club',
  NUMBER_GAME: '/numbergame',
  TP_NUMBER_GAME: '/tp-numbergame',
  KENO: '/keno',
  TP_KENO: '/tp-keno',
  LOTTERY: '/lottery',
  LOTTERY_LAS_VEGAS: '/quayso-disco',
  LOTTERY_CYBER_PUNK: '/lottery-cyber-punk',
  TABLE_GAMES: '/tablegame',
  LODE: '/lo-de-3-mien',
  LODE_SIEUTOC: '/lo-de-sieu-toc',
  LODE_3MIEN: '/lo-de-3-mien-ii',
  LODE_DAICAT: '/lo-de-dai-cat',
  A_SPORTS: `/${SLUG_SPORTS.A_SPORTS}`,
  M_SPORTS: `/${SLUG_SPORTS.M_SPORTS}`,
  C_SPORTS: `/${SLUG_SPORTS.C_SPORTS}`,
  K_SPORTS: `/${SLUG_SPORTS.K_SPORTS}`,
  V_GAMING: '/vgaming',
  VIRTUAL_CASINO: '/song-bai-ao',
  QUAYSO_ATOM: '/quayso-atom',
  KENO_VIETLOT: '/keno-vietlott'
}

export const IGNORE_MOBILE_FOOTER_URL = [
  '/account',
  '/the-thao/lich-thi-dau',
  '/404',
  '/maintenance',
  `/${INSTRUCTION_SLUGS.ABOUT_US}`,
  `/${INSTRUCTION_SLUGS.HOW_TO_BET}`,
  `/${INSTRUCTION_SLUGS.HOW_TO_CREATE_ACCOUNT}`,
  '/huong-dan-nap-rut-tien',
  '/khuyen-mai-ca-cuoc',
  `/${INSTRUCTION_SLUGS.TRIAL_ACCOUNT}`,
  '/cau-hoi-thuong-gap',
  `/${INSTRUCTION_SLUGS.WHAT_IS_BONG88}`,
  `/${INSTRUCTION_SLUGS.WHAT_IS_BONGK}`,
  `/${INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONG88}`,
  `/${INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONGK}`,
  `/${INSTRUCTION_SLUGS.INTERMEDIATE_BETS}`,
  `/${INSTRUCTION_SLUGS.IS_REPUTABLE}`,
  `/${INSTRUCTION_SLUGS.SUPPORT}`,
  `/${INSTRUCTION_SLUGS.HOW_TO_DEPOSIT}`,
  `/${INSTRUCTION_SLUGS.HOW_TO_WITHDRAW}`,
  `/${INSTRUCTION_SLUGS.HOW_TO_TRANSFER}`,
  '/huong-dan',
  '/account-trial',
  `/${INSTRUCTION_SLUGS.PRIVACY_POLICY}`
]

export const LOBBY_GAME_URLS = {
  HOME: '/',
  SPORTS: '/the-thao',
  SCHEDULES: '/the-thao/lich-thi-dau',
  CASINO: '/live-casino',
  ALL_GAME: '/lobby-game',
  INSTANT_GAMES: '/lobby-game?type=cuoc-sieu-toc',
  SLOT: '/lobby-game?type=slots',
  FISHING: '/lobby-game?type=ban-ca',
  LODE: '/lobby-game?type=lode',
  LOTTERY: '/lobby-game?type=quay-so',
  QUICKGAME: '/lobby-game?type=dau-tri',
  INGAME: '/lobby-game?type=ingame',
  TABLE_GAMES: '/lobby-game?type=table-games',
  NO_HU: '/lobby-game?type=no-hu,slots',
  GAME_BAI: '/lobby-game?type=game-bai',
  BATTLE_GAMES: '/lobby-game?type=battle',
  OTHERS: '/lobby-game?type=other'
}

export const ULR_LOBBY_IFRAME_GAMES = [
  '/lo-de-sieu-toc',
  '/lo-de-3-mien',
  '/lo-de-dai-cat',
  '/quayso-disco',
  '/tp-keno',
  '/lottery-cyber-punk'
]

export const MENU_HEDER_SLUGS = ['/lobby-game?type=lode']

const {
  VIRTUAL_SPORTS,
  ESPORTS,
  LIVE_CASINO,
  VIRTUAL_GAME,
  V_GAMING,
  NUMBER_GAME,
  TP_NUMBER_GAME,
  KENO,
  TP_KENO,
  LOTTERY_CYBER_PUNK,
  LOTTERY_LAS_VEGAS,
  TABLE_GAMES,
  LODE,
  LODE_DAICAT,
  LODE_SIEUTOC,
  A_SPORTS,
  M_SPORTS,
  K_SPORTS,
  C_SPORTS,
  VIRTUAL_CASINO,
  LOTTERY
} = IFRAME_GAME_URLS

const heightValueSport = '916px'
const heightValueLoDe = '885px'
const heightValueKeno = '1921px'
const heightValueLottery = '768px'

export const mappingIframeGames = {
  [VIRTUAL_SPORTS]: {
    height: heightValueSport
  },
  [ESPORTS]: {
    height: heightValueSport
  },
  [LIVE_CASINO]: {
    height: heightValueSport
  },
  [VIRTUAL_GAME]: {
    height: heightValueSport
  },
  [TABLE_GAMES]: {
    height: heightValueLoDe
  },
  [LODE]: {
    height: heightValueLoDe
  },
  [LODE_SIEUTOC]: {
    height: heightValueLoDe
  },
  [LODE_DAICAT]: {
    height: heightValueLoDe
  },
  [V_GAMING]: {
    height: heightValueLoDe
  },
  [NUMBER_GAME]: {
    height: '950px'
  },
  [TP_NUMBER_GAME]: {
    height: heightValueSport
  },
  [KENO]: {
    height: heightValueKeno
  },
  [TP_KENO]: {
    height: heightValueKeno
  },
  [LOTTERY_LAS_VEGAS]: {
    height: heightValueLottery
  },
  [LOTTERY_CYBER_PUNK]: {
    height: heightValueLottery
  },
  [LOTTERY]: {
    height: heightValueSport
  },
  [A_SPORTS]: {
    height: heightValueSport
  },
  [M_SPORTS]: {
    height: heightValueSport
  },
  [C_SPORTS]: {
    height: heightValueSport
  },
  [K_SPORTS]: {
    height: heightValueSport
  },
  [VIRTUAL_CASINO]: {
    height: heightValueSport
  },
  [`${NUMBER_GAME}?sportId=164`]: {
    height: heightValueSport
  },
  [`${NUMBER_GAME}?sportId=161`]: {
    height: heightValueSport
  },
  [`${NUMBER_GAME}?sportId=soccerlottery`]: {
    height: heightValueSport
  }
}

export const RESET_PASSWORD_URL = '/reset-password'
export const PAGE_NOT_FOUND = '/404'

// Event router
export const EVENT = {
  PREMIER_LEAGUE_RANKING: '/dua-top-ngoai-hang-anh',
  HALLOWEEN: '/vong-quay-ma-quai'
}
